import React from 'react';
import { useSelector } from 'react-redux';
import { DataModelToolHelpers } from "../../Helpers/DataModelToolHelpers";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import { saveFileWithDialog, FileTypes } from "../../Utils/FileSaveDialog";

interface RootState {
    refreshLoadedFile: { isLoading: boolean };
    pickAFile: { 
        fileLength: number | null; 
        fileName: string;
        currentDataContents: string;
    };
}

const SaveAsSQLFile: React.FC = () => {
    const isLoading = useSelector((state: RootState) => state.refreshLoadedFile.isLoading);
    const currentFileLength = useSelector((state: RootState) => state.pickAFile.fileLength);
    const currentFileName = useSelector((state: RootState) => state.pickAFile.fileName);
    const currentDataContents = useSelector((state: RootState) => state.pickAFile.currentDataContents);

    const { CreateContentsFromStates } = ReduxHelpers();

    const { SaveJsonAsSqlFile } = DataModelToolHelpers();

    async function SaveAsSqlFile() {
        CreateContentsFromStates();

        const sqlFileName = currentFileName.toLowerCase().replace(".json", ".sql");
        const sqlToSave = SaveJsonAsSqlFile(currentDataContents);

        // Use native save dialog with suggested filename
        await saveFileWithDialog(sqlToSave, {
            suggestedName: sqlFileName,
            types: FileTypes.SQL
        });
    }

    return (
        <button disabled={currentFileLength == null || isLoading} onClick={SaveAsSqlFile} title="Save As SQL">
            Save As SQL
        </button>
    );
};

export default SaveAsSQLFile;